import {Component, Input} from '@angular/core';
import {ISharedLoadingProgressPresentation} from '../../../shared-models/loading/shared-loading-progress.interface';
import {DEFAULT_LOADER_INFINITE, ISharedLoadingG} from '../../models/animations';

@Component({
  selector: 'app-shared-loading-progress',
  templateUrl: './shared-loading-progress.component.html',
  styleUrls: ['./shared-loading-progress.component.scss'],
  standalone: false,
})
export class SharedLoadingProgressComponent {
  @Input() message = 'Loading…';
  @Input() presentation: ISharedLoadingProgressPresentation | null = null;
  @Input() compact = false;

  protected readonly animation: Readonly<ISharedLoadingG> = DEFAULT_LOADER_INFINITE;

  get displayMessage(): string {
    return this.presentation?.message ?? this.message;
  }

  get progressPercent(): number {
    const presentation = this.presentation;
    if (!presentation?.totalSteps) {
      return 0;
    }
    return Math.min(100, Math.round((presentation.step / presentation.totalSteps) * 100));
  }

  isStepComplete(stepIndex: number): boolean {
    return (this.presentation?.step ?? 0) > stepIndex + 1;
  }

  isStepActive(stepIndex: number): boolean {
    return (this.presentation?.step ?? 0) === stepIndex + 1;
  }
}
